<template>
    <panel-template>
        <template #content>
            <ui-breadcrumbs design="full" :container="false">
                <template #left>
                    Dashboard
                </template>
            </ui-breadcrumbs>

            <dash-user-bar />

            <section class="section-highlight">
                <grid-container>
                    <div class="title">
                        <div class="icon">
                            <i class="fal fa-chart-bar"/>
                        </div>
                        <div class="texts">
                            <h2>Resumo de produtividade.</h2>
                            <p>Acompanhe seus resultados em tempo real.</p>
                        </div>
                    </div>
                </grid-container>
                <grid-container>
                    <grid-row wrap="s1140">
                        <grid-col>
                            <dash-clients-graphic />
                        </grid-col>
                        <dash-infos />
                    </grid-row>
                </grid-container>
            </section>
            <section class="dashboard-page-content">
                <grid-container>
                    <grid-row block mb="30">
                        <grid-col>
                            <ui-card-toggle-filter
                                :title="stageTitle"
                                filter-label="Origem"
                                icon="fal fa-user-headset"
                                item="customers/card-row"
                                :no-items-msg="stageMensage"
                                no-items-btn-text="Ver clientes cadastrados"
                                no-items-btn-url="/vendas/negocios/lista"
                                :max-height="450"
                                service="deal"
                                q=""
                                :owners="true"
                                :page="1"
                                :per_page="200"
                                :others="{ funnel_stage_position: 0 }"
                            />
                        </grid-col>
                    </grid-row>

                    <grid-row mb="30" wrap="md">
                        <grid-col v-if="checkMenuAllowed('agenda')">
                            <ui-card-toggle-filter
                                title="Tarefas do Dia"
                                filter-label="Tipo"
                                icon="fal fa-comment-alt-check"
                                item="tasks/card"
                                filter-name="type"
                                no-items-msg="Nenhuma tarefa pendente"
                                no-items-btn-text="Cadastrar tarefa"
                                no-items-btn-url-legacy="vendas/clientes/tarefas#cadastrar"
                                :max-height="450"
                                service="task"
                                status="open"
                                :per_page="200"
                                :others="{
                                    dates: [
                                        getToday().format('YYYY-MM-DD'),
                                        getToday().format('YYYY-MM-DD'),
                                    ],
                                }"
                            />
                        </grid-col>

                        <grid-col v-if="checkMenuAllowed('novidades')">
                            <ui-card-toggle-filter
                                title="Últimas Novidades"
                                filter-label="Categoria"
                                icon="fal fa-mug-hot"
                                item="news/preview"
                                no-items-msg="Nenhuma novidade encontrada"
                                no-items-btn-text="Visualizar novidades"
                                no-items-btn-url="comunicacao/novidades/listar"
                                :max-height="450"
                                service="novelty"
                                :page="1"
                                :per_page="200"
                                filter_url="{filter}/category"
                            />
                        </grid-col>
                    </grid-row>

                    <grid-row mb="30" wrap="md">
                        <grid-col v-if="checkMenuAllowed('propostas')">
                            <ui-card-toggle-filter
                                title="Propostas"
                                filter-label="Status"
                                icon="fal fa-file-check"
                                item="proporsals/card-row"
                                filter-name="funnel_stage_status_id"
                                no-items-msg="Nenhuma proposta cadastrada."
                                no-items-btn-text="Visualizar propostas"
                                no-items-btn-url-legacy="vendas/negocios/propostas"
                                :max-height="450"
                                service="proposal"
                                :owners="true"
                                :page="1"
                                :per_page="200"
                                :others="{ funnel_stage_win_probability: 'proposal' }"
                            />
                        </grid-col>

                        <grid-col v-if="checkMenuAllowed('reservas')">
                            <ui-card-toggle-filter
                                title="Reservas e unidades"
                                filter-label="Origem"
                                icon="fal fa-ticket-alt"
                                item="reserves/card"
                                no-items-msg="Não há reservas cadastradas"
                                no-items-btn-text="Reservar unidade"
                                no-items-btn-url-legacy="guia/reserves"
                                :max-height="450"
                                :show-filter="false"
                                modal="global--request-reserve"
                                service="reserve"
                                q=""
                                :page="1"
                                :per_page="200"
                                :status="true"
                            />
                        </grid-col>
                    </grid-row>
                </grid-container>
            </section>
        </template>
        <template #sidebar>
            <!--
				Remover o display none para ativar este recurso
				local da ativação: views/dashboard/components/dash-sidebar/style.styl
				linha 9
			-->
            <dash-sidebar />
        </template>
    </panel-template>
</template>

<script>
	import PanelTemplate from '@/templates/page-dashboard'
	import { storage } from '@/services/storage'
	import { uiBreadcrumbs } from '@/components/ui'
	import { uiCardToggleFilter } from '@/components/ui/cards'
	import { gridContainer, gridRow, gridCol } from '@/components/ui/grid'

	import DashClientsGraphic from './components/dash-clients-graphic'
	import DashSidebar from './components/dash-sidebar'
	import DashUserBar from './components/dash-user-bar'
	import DashInfos from './components/dash-infos'

	import { funnel, configuration } from '@/services/axios'

	import axios from 'axios'

	export default {
        name: 'views-dashboard',

		components: {
			uiCardToggleFilter,
			PanelTemplate,
			uiBreadcrumbs,
			DashSidebar,
			DashClientsGraphic,
			DashUserBar,
			gridContainer,
			gridRow,
			gridCol,
			DashInfos,
		},

		data() {
			return {
				loadDashClient: true,
				loadDashSales: true,
				loadDashVisits: true,
				todayDate: null,
				domainUrl: null,
				dashInfosData: {
					customersFromMonth: 0,
					dealsWon: 0,
					tasksVisit: 0,
				},
				stageTitle: '',
				stageMensage: '',
			}
		},

		created() {
			this.allowed_menu = storage.get('allowed_menu')
			this.todayDate = this.getToday().format('[Hoje são] DD [de] MMMM [de] YYYY')
			this.getConfigurations()
			this.getFirtStage()
		},

		methods: {
			getConfigurations() {
				configuration.getConfigurations().then(() => {})
			},
			getToday() {
				const moment = require('moment')
				require('moment/locale/pt-br')

				return moment()
			},
			checkMenuAllowed(name) {
				return this.allowed_menu.includes(name)
			},
			async getFirtStage() {
				/** Gera o token para cancelar as requisições */
				const CancelToken = axios.CancelToken
				const source = CancelToken.source()
				const config = { cancelToken: source.token }
				await funnel
					.getStages(config)
					.then((response) => {
						this.stageTitle = response.data[0].name
						this.stageMensage = `Nenhum cliente em: ${response.data[0].name}.`
					})
					.catch((error) => {
						console.error(error)
					})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl';
</style>
